
import { MenuItem, ListItemText, ListItemIcon } from '@mui/material'
import { Edit3, Info, Trash2 } from 'react-feather'

// Imports custom
import {
    CustomTableData,
    CustomDropDown,
    TooltipInformation,
    TooltipApprovalInfo
} from 'common'

const AppliesTable = ({useFetchInit}) => {

    const {
        FetchData,
        Actions
    }= useFetchInit

    const { fetchAllLeaseApplications } = FetchData
    const { leaseApplications } = fetchAllLeaseApplications


    const { handleClickDeleteLease, handleClickFetchInfoLease, handleClickEditLease } = Actions
    

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const {idcontrato, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                return(
                    <TooltipInformation
                        idregistro={idcontrato}
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "contrato_fecha", headerName: "FECHA", minWidth: 150, filter: true },
        { field: "contrato_codigo", headerName: "IDENTIFICADOR", minWidth: 200, filter: true },        
        { field: "descripcion_casa", headerName: "DESCRIPCION DE LA CASA", minWidth: 300, filter: true },
        { field: "datos_cliente", headerName: "DATOS DEL CLIENTE", minWidth: 300, filter: true },
        { field: "plazo_meses", headerName: "PLAZO", minWidth: 150, filter: true },
        { 
            field: "contrato_costo_alquiler", headerName: "ALQUILER (Q)", minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 250,
            maxWidth: 250,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellClass: (params) => {

                if(params.value === 'PENDIENTE APROBACION') return 'bg-warning';
                if(params.value === 'PENDIENTE CONTRATO') return 'bg-warning';
                if(params.value === 'BORRADOR') return 'bg-warning';
                if(params.value === 'RECHAZADO') return 'bg-danger';
                if(params.value === 'DEVUELTO A GESTOR') return 'bg-danger';

            },
            cellRenderer: (params) => {
                const { value } = params
                const { aprobacion_usuario, aprobacion_fecha } = params.data

                return (
                    <TooltipApprovalInfo
                        texto_approval={value}
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                );

            }
        },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                const { idcontrato, aprobacion_check, estado } = params.data

                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        {( ['PENDIENTE APROBACION', 'PENDIENTE CONTRATO', 'RECHAZADO'].includes(aprobacion_check) ) && (
                            <MenuItem
                                onClick={() => handleClickFetchInfoLease(idcontrato)}
                            >
                                <ListItemIcon> <Info color="black"/> </ListItemIcon>
                                <ListItemText primary="Informacion" />
                            </MenuItem>
                        )}
                        {( ['BORRADOR', 'DEVUELTO A GESTOR'].includes(aprobacion_check) ) && (
                            <div>
                                <MenuItem
                                    onClick={() => handleClickEditLease(idcontrato)}
                                >
                                    <ListItemIcon> <Edit3 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Editar Info." />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickDeleteLease(idcontrato)}
                                >
                                    <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Eliminar" />
                                </MenuItem>
                            </div>
                        )}
                    </CustomDropDown>
                )
            }
        },
    ]

    return (
        <div className='content'>
            <CustomTableData 
                rowConfig={leaseApplications}
                columnConfig={columnConfig}
            />
        </div>
    )
}

export {
    AppliesTable
}